import Head from 'next/head'
import { useRouter } from 'next/router'

import type { UiPageTitleProps } from '../types/pageTitle'

export const UiPageTitle = ({
  canonical,
  defaultOgImage,
  description,
  metaData,
  noIndex,
  suffix,
  title,
}: UiPageTitleProps) => {
  const router = useRouter()
  const titleWithSuffix = title?.trim() ? `${title} | ${suffix}` : suffix
  const cleanTitle = titleWithSuffix.replace(/<\/?[^>]+(>|$)/g, '') // strips html tags from title

  const canonicalUrl = (
    process.env.BASE_URL + (router.asPath === '/' ? '' : router.asPath)
  ).split('?')[0]

  return (
    <Head>
      <title key="title">{cleanTitle}</title>
      <meta name="description" content={description} key="description" />
      <meta property="og:title" content={titleWithSuffix} key="og:title" />
      <meta
        property="og:description"
        content={description}
        key="og:description"
      />
      <meta
        property="og:image"
        content={metaData?.image || defaultOgImage}
        key="og:image"
      />
      {canonical ? (
        <link rel="canonical" href={canonicalUrl} key="canonical" />
      ) : null}
      {noIndex ? (
        <meta name="robots" content="noindex,nofollow" key="robots" />
      ) : null}
    </Head>
  )
}
